import React from 'react';
import { Loader } from '../loader';
import { Images } from 'utils';
import { PriceRow } from '../table';


export const BulkActionToolbar = ({
                                    selectedCount,
                                    handleSelectOrUnselectAll,
                                    isAllSelected,
                                    handleCreateBatch,
                                    handleMoveTo,
                                    handleUnpaid,
                                    loadingCreateBatch,
                                    loadingMoveTo,
                                    loadingUnpaid,
                                    allAmount,
                                    handleClose,
                                  }) => {
  return (
    <div className='bulk-action-toolbar-wrapper'>
      <div className='bulk-action-toolbar-selected-info'>
        <div className='bulk-action-toolbar-selected-count'>
          {selectedCount}
        </div>

        <p className='bulk-action-toolbar-selected-text'>
          Selected
        </p>
      </div>

      <button
        className='bulk-action-toolbar-select-all-btn'
        onClick={(e) => handleSelectOrUnselectAll(e, !isAllSelected)}
      >
        <div className='bulk-action-toolbar-select-all-svg'>
          <img src={Images.selectionSvg} alt='selection' />
        </div>
        {isAllSelected ? 'Unselect All' : 'select All'}
      </button>

      {handleCreateBatch &&
        <button
          className='bulk-action-toolbar-create-batch-btn'
          onClick={handleCreateBatch}
          disabled={!!loadingCreateBatch?.length}
        >
          {loadingCreateBatch?.length ?
            <Loader styles={{
              color: 'white',
              minWidth: 15,
              maxWidth: 15,
              minHeight: 15,
              maxHeight: 15,
            }} /> : 'Create Batch'}
        </button>
      }

      {handleMoveTo &&
        <button
          className='bulk-action-toolbar-move_or_unpaid-btn'
          style={{ width: 70 }}
          onClick={handleMoveTo}
          disabled={!!loadingMoveTo?.length}
        >
          {loadingMoveTo?.length ? <Loader styles={{
            color: 'white',
            minWidth: 15,
            maxWidth: 15,
            minHeight: 15,
            maxHeight: 15,
          }} /> : 'Move to'}
        </button>
      }

      {handleUnpaid &&
        <button
          className='bulk-action-toolbar-move_or_unpaid-btn'
          style={{ width: 62 }}
          onClick={handleUnpaid}
          disabled={!!loadingUnpaid?.length}
        >
          {loadingUnpaid?.length ? <Loader styles={{
            color: 'white',
            minWidth: 15,
            maxWidth: 15,
            minHeight: 15,
            maxHeight: 15,
          }} /> : 'Unpaid'}
        </button>
      }

      {!!allAmount &&
        <div className='bulk-action-toolbar-amount-wrapper'>
          <p>
            Total:
          </p>
          <PriceRow info={allAmount} textWidth={4} />
        </div>
      }

      <button
        className='bulk-action-toolbar-close-btn'
        onClick={handleClose}
      >
        <img src={Images.closeActions} alt='close' />
      </button>
    </div>
  );
};

